<div class="portal-empty-state">
  <div class="portal-empty-state__content">
    <h2 class="portal-empty-state__title">{{ title }}</h2>
    <p *ngIf="description" class="portal-empty-state__description">{{ description }}</p>
    <ng-content select="[emptyStateDescription]"></ng-content>
    <button
      *ngIf="actionLabel"
      type="button"
      class="portal-empty-state__action"
      (click)="onActionClick()">
      {{ actionLabel }}
    </button>
  </div>
</div>
